<div class="amway-header-language visible-desktop"
  [ngClass]="{active:isOpen}">
  <div class="ahl-btn"
    (click)="togglePopup()">{{selectedLanguage?.label}}</div>
  <div class="amway-header-modal for-changeLang"
    [ngClass]="{active:isOpen}">
    <div class="bg-ahm sp"
      (click)="togglePopup()"></div>
  </div>
  <div class="ahl-menu">
    <div class="ahl-menu-list"
      *ngFor="let lang of languageList"
      [ngClass]="{'--active': lang.selected}"
      (click)="onLanguageChange(lang)">{{lang.label}}</div>
  </div>
</div>

<div class="shop-list-btn-lang visible-mobile">
  <ng-container  *ngFor="let lang of languageList,let i=index">
    <div class="shop-list-btn-lang-box  shop-list-btn-lang-{{lang.code}} " 
    [ngClass]="{'active': lang.selected}"
    data-lang="{{lang.code}}"
    (click)="toggleLanguage(i)">
    </div>
  </ng-container>
</div>
